<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">
                       
                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li class="active">
                                  <router-link :title="' تقرير الاشعارات'" :to="{name: 'report.notifications'}"> تقرير الاشعارات</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div class="row"> 
                    <div class="col-lg-12 col-md-12 layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>
                                              <i class="flaticon-computer-4"></i> 
                                          تقرير الاشعارات

                                        </h4>
                                    </div>          
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">
                              <form @submit.prevent="getIndexData(1)" v-if="1" style="border: 1px solid #DDD;padding: 20px" class="mb-4">
                                    <div class="form-row">
                                      <div class="col-md-6 mt-2">
                                          <label for="">التاريخ من</label>
                                          <date-picker v-model="data.searching.date_from" :editable="true" :calendar="'hijri'"></date-picker>
                                        </div>
                                        <div class="col-md-6 mt-2">
                                          <label for="">التاريخ الى</label>
                                          <date-picker v-model="data.searching.date_to" :editable="true" :calendar="'hijri'"></date-picker>
                                        </div>
                                        <div class="col-md-6 mt-2">
                                          <label for="">اسم الطالب</label>
                                          <input type="text" name="student" v-model="data.searching.student" class="form-control">
                                        </div>
                                       
                                        
                                        <div class="col-md-12 mt-4">
                                          <button type="submit" name="time" class="search-btn-wg btn-creative btn-3 btn-3e flaticon-search-1"> <span>بحث</span></button>

                                        </div>
                                    </div>
                                </form>
                                <div class="table-responsive">
                                   <div class="row mb-2">
                                      <div class="col-md-1">
                                        <span>إظهار</span>
                                        <select v-model="data.searching.perPage" @change="getIndexData(1)" class="form-control">
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                      </div>
                                    </div>
                                    <table class="table table-bordered mb-4">
                                        <thead>
                                            <tr>
                                              <th style="width: 20%;">
                                                ولى الامر
                                              </th>
                                                <th style="width: 20%;">العنوان</th>
                                                <th style="width: 30%;">رد ولى الامر </th>
                                                <th style="width: 10%;">الحالة</th>
                                                <th style="width: 20%;">وقت الاشعار</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in data.data" :key="index">
                                                <td style="width: 20%;">{{item.user ? item.user.name : 'غير معروف' }}</td>
                                                <td style="width: 20%;">{{item.title}}</td>
                                                <td style="width: 30%;">
                                                  <span v-if="item.replies_count">
                                                    {{ item.replies[0] ? item.replies[0].content : '' }}
                                                    <br>
                                                  </span>
                                                  <span v-else>
                                                    لا يوجد رد
                                                  </span>
                                                  <a v-if="item.replies_count" class="text-danger" target="_blank" :href="'/show-parentNotifications?id=' + item.id">
                                                    مشاهدة الردود
                                                  </a>
                                                </td>
                                                <td style="width: 10%;">
                                                  <i class="flaticon-single-tick text-success" v-if="item.seen_at != null"></i>
                                                  <i class="flaticon-bell-3 text-warning" v-else></i>
                                                </td>
                                                <td style="width: 20%;">
                                                  {{ item.sent_date_formate }}
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                          <tr>
                                              <th style="width: 20%;">
                                                ولى الامر
                                              </th>
                                                <th style="width: 20%;">العنوان</th>
                                                <th style="width: 30%;">رد ولى الامر </th>
                                                
                                                <th style="width: 10%;">الحالة</th>
                                                <th style="width: 20%;">وقت الاشعار</th>
                                            </tr>
                                        </tfoot>
                                        
                                    </table>
                                </div>
                                <div class="row">
                                  <div class="col-md-6">
                                    <simple-pagination :data="data.paginated" @getIndexData="getIndexData($event)"></simple-pagination>
                                  </div>
                                  <div class="col-md-6 mt-4">
                                    <table-info v-if="Object.keys(data.paginated).length" :data="data.paginated"></table-info>
                                  </div>
                                </div>
                            </div>
                        </div>
                         
                    </div>
                   
                </div>
            </div>


</template>
<script>
import VueDatetimeJs from 'vue-datetime-js'

export default {
  components: {
    datePicker: VueDatetimeJs
  },
  data() {
    return {
      data: {
        data: {},
        searching:{
            id: '',
            title: '',
            perPage: 10,
           sorting: 'desc',
           date_from: '',
           date_to: '',
           student: '',
        },
        paginated: {},
        showFilter: false,
      }
    };
  },
  created(){
      this.getIndexData(1);
  },
  methods: {
     resortData(){
        this.data.searching.sorting = this.data.searching.sorting == 'asc' ? 'desc' : 'asc';
        this.getIndexData(1);
      },
      getIndexData(page){
        this.$baseApi.get('reports/notifications?page=' + page, {
                    params: this.data.searching
                }).then((response)=>{
            if(response.data.code == 200){
               this.data.paginated = response.data.data;
               this.data.data = response.data.data.data;

            }else{
                alert(response.data.error.error);
            }
        });
      },
      deleteData(data){
          this.data.data.splice(this.data.data.indexOf(data), 1);
      },
    clearFilter(items) {
      this.data.showFilter = !this.data.showFilter
      if (!this.data.showFilter) {
        for (const itemsKey in items) {
          this.data.searching[itemsKey] = ''
        }
        this.getIndexData(1);
      }
    },
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    }
  }
};
</script>
<style>
</style>
